import {
  ExtractlyOfficeApiAccessDeniedError,
  ExtractlyOfficeApiActivityLimitReachedError,
  ExtractlyOfficeApiApiNotAvailableError,
  ExtractlyOfficeApiApiNotFoundError,
  ExtractlyOfficeApiBadPasswordError,
  ExtractlyOfficeApiConflictError,
  ExtractlyOfficeApiContentLengthRequiredError,
  ExtractlyOfficeApiEmptyChartSeriesError,
  ExtractlyOfficeApiFilteredRangeConflictError,
  ExtractlyOfficeApiFormulaLengthExceedsLimitError,
  ExtractlyOfficeApiGeneralExceptionError,
  ExtractlyOfficeApiHostRestartNeededError,
  ExtractlyOfficeApiInactiveWorkbookError,
  ExtractlyOfficeApiInsertDeleteConflictError,
  ExtractlyOfficeApiInvalidArgumentError,
  ExtractlyOfficeApiInvalidBindingError,
  ExtractlyOfficeApiInvalidOperationError,
  ExtractlyOfficeApiInvalidOperationInCellEditModeError,
  ExtractlyOfficeApiInvalidReferenceError,
  ExtractlyOfficeApiInvalidRequestError,
  ExtractlyOfficeApiInvalidRibbonDefinitionError,
  ExtractlyOfficeApiInvalidSelectionError,
  ExtractlyOfficeApiItemAlreadyExistsError,
  ExtractlyOfficeApiItemNotFoundError,
  ExtractlyOfficeApiMemoryLimitReachedError,
  ExtractlyOfficeApiMergedRangeConflictError,
  ExtractlyOfficeApiNonBlankCellOffSheetError,
  ExtractlyOfficeApiNotImplementedError,
  ExtractlyOfficeApiOperationCellsExceedLimitError,
  ExtractlyOfficeApiPivotTableRangeConflictError,
  ExtractlyOfficeApiRangeExceedsLimitError,
  ExtractlyOfficeApiRefreshWorkbookLinksBlockedError,
  ExtractlyOfficeApiRequestAbortedError,
  ExtractlyOfficeApiRequestPayloadSizeLimitExceededError,
  ExtractlyOfficeApiResponsePayloadSizeLimitExceededError,
  ExtractlyOfficeApiServiceNotAvailableError,
  ExtractlyOfficeApiUnauthenticatedError,
  ExtractlyOfficeApiUndoNotSupportedError,
  ExtractlyOfficeApiUnsupportedFeatureError,
  ExtractlyOfficeApiUnsupportedOperationError,
  ExtractlyOfficeApiUnsupportedSheetError,
  ExtractlyOfficeApiUnknownError,
  ExtractlyOfficeApiErrorClass,
} from '../errors/office_api_errors'

export const getOfficeApiError = (error: unknown): ExtractlyOfficeApiErrorClass => {
  if (!error || typeof error !== 'object' || !('code' in error)) {
    return new ExtractlyOfficeApiUnknownError('Unknown Office API error')
  }

  const officeError = error as OfficeExtension.Error
  const message = officeError.message || 'Office API error occurred'

  switch (officeError.code) {
    case 'AccessDenied':
      return new ExtractlyOfficeApiAccessDeniedError(message)
    case 'ActivityLimitReached':
      return new ExtractlyOfficeApiActivityLimitReachedError(message)
    case 'ApiNotAvailable':
      return new ExtractlyOfficeApiApiNotAvailableError(message)
    case 'ApiNotFound':
      return new ExtractlyOfficeApiApiNotFoundError(message)
    case 'BadPassword':
      return new ExtractlyOfficeApiBadPasswordError(message)
    case 'Conflict':
      return new ExtractlyOfficeApiConflictError(message)
    case 'ContentLengthRequired':
      return new ExtractlyOfficeApiContentLengthRequiredError(message)
    case 'EmptyChartSeries':
      return new ExtractlyOfficeApiEmptyChartSeriesError(message)
    case 'FilteredRangeConflict':
      return new ExtractlyOfficeApiFilteredRangeConflictError(message)
    case 'FormulaLengthExceedsLimit':
      return new ExtractlyOfficeApiFormulaLengthExceedsLimitError(message)
    case 'GeneralException':
      return new ExtractlyOfficeApiGeneralExceptionError(message)
    case 'HostRestartNeeded':
      return new ExtractlyOfficeApiHostRestartNeededError(message)
    case 'InactiveWorkbook':
      return new ExtractlyOfficeApiInactiveWorkbookError(message)
    case 'InsertDeleteConflict':
      return new ExtractlyOfficeApiInsertDeleteConflictError(message)
    case 'InvalidArgument':
      return new ExtractlyOfficeApiInvalidArgumentError(message)
    case 'InvalidBinding':
      return new ExtractlyOfficeApiInvalidBindingError(message)
    case 'InvalidOperation':
      return new ExtractlyOfficeApiInvalidOperationError(message)
    case 'InvalidOperationInCellEditMode':
      return new ExtractlyOfficeApiInvalidOperationInCellEditModeError(message)
    case 'InvalidReference':
      return new ExtractlyOfficeApiInvalidReferenceError(message)
    case 'InvalidRequest':
      return new ExtractlyOfficeApiInvalidRequestError(message)
    case 'InvalidRibbonDefinition':
      return new ExtractlyOfficeApiInvalidRibbonDefinitionError(message)
    case 'InvalidSelection':
      return new ExtractlyOfficeApiInvalidSelectionError(message)
    case 'ItemAlreadyExists':
      return new ExtractlyOfficeApiItemAlreadyExistsError(message)
    case 'ItemNotFound':
      return new ExtractlyOfficeApiItemNotFoundError(message)
    case 'MemoryLimitReached':
      return new ExtractlyOfficeApiMemoryLimitReachedError(message)
    case 'MergedRangeConflict':
      return new ExtractlyOfficeApiMergedRangeConflictError(message)
    case 'NonBlankCellOffSheet':
      return new ExtractlyOfficeApiNonBlankCellOffSheetError(message)
    case 'NotImplemented':
      return new ExtractlyOfficeApiNotImplementedError(message)
    case 'OperationCellsExceedLimit':
      return new ExtractlyOfficeApiOperationCellsExceedLimitError(message)
    case 'PivotTableRangeConflict':
      return new ExtractlyOfficeApiPivotTableRangeConflictError(message)
    case 'RangeExceedsLimit':
      return new ExtractlyOfficeApiRangeExceedsLimitError(message)
    case 'RefreshWorkbookLinksBlocked':
      return new ExtractlyOfficeApiRefreshWorkbookLinksBlockedError(message)
    case 'RequestAborted':
      return new ExtractlyOfficeApiRequestAbortedError(message)
    case 'RequestPayloadSizeLimitExceeded':
      return new ExtractlyOfficeApiRequestPayloadSizeLimitExceededError(message)
    case 'ResponsePayloadSizeLimitExceeded':
      return new ExtractlyOfficeApiResponsePayloadSizeLimitExceededError(
        message
      )
    case 'ServiceNotAvailable':
      return new ExtractlyOfficeApiServiceNotAvailableError(message)
    case 'Unauthenticated':
      return new ExtractlyOfficeApiUnauthenticatedError(message)
    case 'UndoNotSupported':
      return new ExtractlyOfficeApiUndoNotSupportedError(message)
    case 'UnsupportedFeature':
      return new ExtractlyOfficeApiUnsupportedFeatureError(message)
    case 'UnsupportedOperation':
      return new ExtractlyOfficeApiUnsupportedOperationError(message)
    case 'UnsupportedSheet':
      return new ExtractlyOfficeApiUnsupportedSheetError(message)
    case 'UnknownError':
      return new ExtractlyOfficeApiUnknownError(message)
    default:
      return new ExtractlyOfficeApiUnknownError(
        `Unknown Office API error code: ${officeError.code}`
      )
  }
}

export const isExtractlyOfficeApiError = (
  error: unknown
): error is ExtractlyOfficeApiErrorClass => {
  // Check if it's an object with the right properties
  if (!error || typeof error !== 'object') {
    return false
  }

  // Type assertion for property access
  const err = error as any

  // Check for required properties and structure
  return (
    error instanceof ExtractlyOfficeApiErrorClass ||
    (typeof err.code === 'string' &&
      typeof err.message === 'string' &&
      typeof err.name === 'string' &&
      err.name.startsWith('ExtractlyOfficeApi') &&
      err.name.endsWith('Error'))
  )
}
